import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Carousel } from "react-responsive-carousel";
import { RootState } from "../../redux/rootReducer";
import styles from "./AwardsRecognition.module.css";

export interface IAwardsAndRecognitions {
    awardId: number,
    awardCode: string,
    title: string,
    description: string,
    image: string,
    displayOrder: number,
    isActive: boolean
}

interface PropsType {
    awardCard: IAwardsAndRecognitions[]
}

export default function AwardsRecognition(props: PropsType) {

    const [awardId, setAwardId] = useState(0);
    const [awardsPerPage, setAwardsPerPage] = useState(3);
    const responsive = useSelector((state: RootState) => state.responsive);
    const [awardList, setAwardList] = useState<IAwardsAndRecognitions[]>(props.awardCard);

    useEffect(() => {
        if (responsive.isMobileSmallScreen) {
            setAwardsPerPage(1);
        }
    }, [])

    function nextSelection() {
        var id = awardId + awardsPerPage;
        if (id >= awardList.length) {
            setAwardId(awardList.length - awardsPerPage);
        }
        else {
            setAwardId(id);
        }
    }

    function previousSelection() {
        var id = awardId - awardsPerPage;
        if (id < 0) {
            setAwardId(0);
        }
        else {
            setAwardId(id);
        }
    }

    return (
        <React.Fragment>
            <div className={`${styles.container}`}>
                <div className={`${styles.heading}`}>
                    awards & recognition
                </div>
                <div className={`${styles.awardsContainer}`}>
                    <Row>
                        {responsive.isMobileLargeScreen || responsive.isMobileSmallScreen || responsive.isTabScreen ?
                            <div>
                                <Carousel
                                    autoPlay={true}
                                    showArrows={false}
                                    swipeable={true}
                                    showStatus={false}
                                    infiniteLoop={true}
                                    showIndicators={true}
                                    showThumbs={false}
                                >
                                    {awardList.map((item, index) => {
                                        return (
                                            <div key={index} className=" justify-content-center">
                                                <div className={`${styles.imgContainer}`} style={{ margin: "2.5rem" }} >
                                                    <img src={item.image} alt={item.title + `-img`} className="img-fluid" title={item.title} />
                                                    <div className={`${styles.descrption}`}>{item.description}</div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </Carousel>

                            </div>
                            :
                            <div>
                                <Row style={{ margin: "0 3rem" }}>
                                    <Col md="4" sm="12">
                                        {awardList[awardId] != undefined ?
                                            <div className="justify-content-center">
                                                <div className={`${styles.imgContainer}`}>
                                                    <img src={awardList[awardId].image} alt={awardList[awardId].title + `-img`} title={awardList[awardId].title} className="img-fluid" />
                                                    <div className={`${styles.descrption}`}>{awardList[awardId].description}</div>
                                                </div>
                                            </div>
                                            : null}
                                    </Col>
                                    <Col md="4" sm="12">
                                        {awardList[awardId + 1] != undefined ?
                                            <div className="justify-content-center">
                                                <div className={`${styles.imgContainer}`}>
                                                    <img src={awardList[awardId + 1].image} alt={awardList[awardId + 1].title + `-img`} title={awardList[awardId + 1].title} className="img-fluid" />
                                                    <div className={`${styles.descrption}`}>{awardList[awardId + 1].description}</div>
                                                </div>
                                            </div>
                                            : null}
                                    </Col>
                                    <Col md="4" sm="12">
                                        {awardList[awardId + 2] != undefined ?
                                            <div className="justify-content-center">
                                                <div className={`${styles.imgContainer}`}>
                                                    <img src={awardList[awardId + 2].image} alt={awardList[awardId + 2].title + `-img`} title={awardList[awardId + 2].title} className="img-fluid" />
                                                    <div className={`${styles.descrption}`}>{awardList[awardId + 2].description}</div>
                                                </div>
                                            </div>
                                            : null}
                                    </Col>
                                </Row>

                                <Row>
                                    <div className={styles.arrowHolder}>
                                        <button className={`${styles.arrowLeft}`} onClick={() => previousSelection()}>
                                            <i className={`fas fa-long-arrow-alt-left fa-3x`} style={{ color: "black" }} />
                                        </button>
                                        <div className={`${styles.titleCount}`} hidden>
                                            {awardId + awardsPerPage} / {awardList.length}
                                        </div>
                                        <button className={`${styles.arrowRight}`} disabled={(awardId + awardsPerPage) >= awardList.length}
                                            onClick={() => nextSelection()}>
                                            <i className={`fas fa-long-arrow-alt-right fa-3x`} style={{ color: "black" }} />
                                        </button>
                                    </div>

                                </Row>

                            </div>
                        }
                    </Row>
                </div>
            </div>
        </React.Fragment >
    )
}